{
  "formTitle": "Register enemy rally",
  "formWhy": "Type the number you read in-game right now. The server stamps the time.",
  "formEnemy": "Enemy roster",
  "formEnemyPick": "Pick one",
  "formEnemyEmpty": "No enemy in the roster list",
  "formEnemyOnlyRoster": "You cannot create a new enemy here. Add it in the roster list on the roster tab.",
  "formPhase": "Phase right now",
  "formPhaseRallying": "rallying",
  "formPhaseMarching": "marching",
  "formPhaseWhy": "The same 0:52 means something different in each phase. In rallying it has not left yet; in marching it is already on the way.",
  "formRemaining": "Time left at that moment",
  "formSubmit": "Add enemy rally",
  "formNeedEnemy": "Pick an enemy.",
  "formAdded": "Added. It stands at the bottom of the list; the order is fixed by registration.",
  "formAnchorWhy": "The server anchors the moment you submit. CT never has to read a clock and write it down.",

  "composeTitle": "defense",
  "composeTitleHint": "Enemy rally sequence",
  "composeWhy": "Listed in the order you registered them. Impact and time left run inside each row, and re-anchoring never moves a row.",
  "composeEmpty": "No enemy rally registered.",
  "composeNextRegister": "Next: add one enemy rally in the form on the left.",
  "composeNextWatch": "Next: when the in-game number changes, re-anchor that row.",
  "composeSignalOwner": "Signal live: {roster}, open in {remaining}",
  "composeSignalPassed": "Signal passed: {roster}, since open {remaining}",
  "composeSignalMuted": "Signal live: {roster}, open in {remaining}. Sound is off",
  "composeSignalPassedMuted": "Signal passed: {roster}, since open {remaining}. Sound was off",
  "composeSignalPassedRang": "Signal passed: {roster}, since open {remaining}. Sound rang on time",
  "composeSignalPassedMissed": "Signal passed: {roster}, since open {remaining}. Sound did not play",
  "composeSignalNone": "No audible signal is running.",

  "rowImpact": "Impact",
  "rowRallyingLeft": "rallying left",
  "rowImpactLeft": "To impact",
  "rowImpactPassed": "Impact passed",
  "rowAnchoredRallying": "rallying anchor",
  "rowAnchoredMarching": "marching anchor",
  "rowEnemyGone": "Enemy off the roster list",
  "rowReanchor": "Re-anchor",
  "rowReanchorWhy": "Type the number on your screen right now. That moment becomes the new baseline.",
  "rowReanchorDone": "Re-anchored. Impact and the squads for this row stand again, and the row stays where it was.",
  "rowRemove": "Delete",
  "rowRemoveArmed": "Press again to delete",
  "rowRemoveWhat": "This one observation row goes away, and the squads tied to this rally go with it.",
  "rowCancel": "Cancel",

  "unknownBand": "Impact unknown (needs input)",
  "unknownWhy": "The roster list has no marching for this enemy, so impact cannot be computed. It sits in the bottom band so it is not mixed with computed rows.",
  "unknownFix": "Put that enemy's marching in the roster list on the roster tab and it moves into its registration place. Re-anchoring in the marching phase works too.",

  "viewTitle": "Defense",
  "viewTitleHint": "When to dispatch",
  "viewWhy": "The trigger is the in-game countdown value to act on; T− is the app counting down to that moment.",
  "viewEmpty": "No enemy rally registered. They stand here once CT adds them.",
  "viewNextImpact": "To next impact",
  "viewNoSound": "Defense has no sound signal. Watch the trigger on screen and dispatch.",
  "viewNoSoundWithAttack": "Defense has no sound signal. The sound about to play is the attack signal named above.",

  "sectionNext": "Next trigger",
  "sectionNone": "Nothing to dispatch",
  "cellTrigger": "Trigger",
  "cellCountdown": "To dispatch",
  "cellImpossible": "Impossible",
  "cellImpossibleWhy": "Too late to dispatch.",
  "cellLateBy": "Late by",
  "cellUnknown": "Impact unknown",
  "cellUnknownWhy": "Nothing can be decided yet.",
  "dimAllImpossible": "Impossible on every rally",
  "dimAllImpossibleWhy": "Marching {marching} is longer than every dispatch window.",
  "dimNothing": "Nothing to dispatch right now",
  "dimMarchingMissing": "Marching needs input",
  "dimMarchingMissingWhy": "Add it in the roster list on the roster tab.",
  "dimWhy": "Not hidden. That this person cannot go is what CT needs to change the assignment.",

  "guideTitle": "What R and M mean",
  "guideRallying": "= dispatch while the enemy is still rallying. The chip's number is the enemy rally's remaining rallying at the moment you dispatch.",
  "guideMarching": "= dispatch while the enemy is already marching. The chip's number is the enemy rally's time to impact at the moment you dispatch.",
  "guideOrder": "Names keep the roster list order and never move as time passes. Inside each name the rows are in dispatch order; a passed row dims but stays put.",

  "tabAttack": "attack view",
  "tabDefense": "defense view",
  "tabWhy": "Both are live at the same time. Switching tabs does not clear a scheduled sound.",
  "presenceHandle": "{n} connected",
  "presenceHandleStale": "no connection",
  "attackWaiting": "There is a confirmed attack ops ({n} rallies). Pick your own rally in the attack view.",
  "attackWaitingGo": "Go to attack view",

  "triggerRallying": "R",
  "triggerMarching": "M"
}
